export default __webpack_public_path__ + "static/05_professional_learning-fe00ae940fa0f59ffb2ba2ce30249adf.png";